var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1035 0.896892C15.9063 -0.300284 13.9584 -0.300248 12.7612 0.896892L5.00702 8.65109C4.93028 8.72784 4.8774 8.82512 4.85469 8.93122L3.89004 13.4416C3.85017 13.6282 3.90751 13.8222 4.04237 13.9571C4.14896 14.0637 4.29254 14.1219 4.44016 14.1219C4.47929 14.1219 4.5187 14.1178 4.5578 14.1094L9.06919 13.1448C9.17532 13.1221 9.2726 13.0692 9.34935 12.9924L17.1033 5.23844C17.6816 4.66076 18 3.88981 18 3.06754C18 2.24531 17.6816 1.47437 17.1035 0.896892ZM5.73855 10.1782L7.82135 12.261L5.17191 12.8276L5.73855 10.1782ZM16.308 4.44265L8.95106 11.7995L6.2004 9.04889L13.5568 1.69248C14.3153 0.933982 15.5494 0.933982 16.3081 1.69269C16.6736 2.05779 16.8749 2.54604 16.8749 3.06754C16.8749 3.58905 16.6736 4.07737 16.308 4.44265ZM15.1785 9.98865V15.8992C15.1785 17.0578 14.2359 18.0004 13.0773 18.0004H2.10023C0.942152 18.0004 0 17.0578 0 15.8992V4.92316C0 3.76452 0.942152 2.82191 2.10023 2.82191H8.01081C8.32148 2.82191 8.57334 3.07377 8.57334 3.38444C8.57334 3.69512 8.32148 3.94698 8.01081 3.94698H2.10023C1.56255 3.94698 1.12511 4.38488 1.12511 4.92313V15.8992C1.12511 16.4374 1.56255 16.8753 2.10023 16.8753H13.0773C13.6155 16.8753 14.0534 16.4374 14.0534 15.8992V9.98865C14.0534 9.67797 14.3053 9.42611 14.6159 9.42611C14.9266 9.42611 15.1785 9.67794 15.1785 9.98865Z",
    fill: "#4B1498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_5288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.84969620a18b824ee179d1b88c36b034.svg";
export { ForwardRef as ReactComponent };